import { render } from "./CalendarHomeNotificationChange.vue?vue&type=template&id=dd59cbae&scoped=true&ts=true"
import script from "./CalendarHomeNotificationChange.vue?vue&type=script&lang=ts"
export * from "./CalendarHomeNotificationChange.vue?vue&type=script&lang=ts"

import "./CalendarHomeNotificationChange.vue?vue&type=style&index=0&id=dd59cbae&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd59cbae"]])

export default __exports__